var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.799 4.165L17.424 2.335C17.2626 2.23139 17.0871 2.15157 16.903 2.098C16.7196 2.03864 16.5287 2.00565 16.336 2H9.5L10.301 7H16.336C16.5 7 16.705 6.963 16.902 6.902C17.099 6.841 17.289 6.757 17.423 6.666L19.798 4.834C19.933 4.743 20 4.622 20 4.5C20 4.378 19.933 4.257 19.799 4.165ZM8.5 0H7.5C7.36739 0 7.24021 0.0526784 7.14645 0.146447C7.05268 0.240215 7 0.367392 7 0.5V4H3.664C3.498 4 3.294 4.037 3.097 4.099C2.899 4.159 2.71 4.242 2.576 4.335L0.201 6.165C0.066 6.256 0 6.378 0 6.5C0 6.621 0.066 6.742 0.201 6.835L2.576 8.667C2.71 8.758 2.899 8.842 3.097 8.902C3.294 8.963 3.498 9 3.664 9H7V17.5C7 17.6326 7.05268 17.7598 7.14645 17.8536C7.24021 17.9473 7.36739 18 7.5 18H8.5C8.63261 18 8.75979 17.9473 8.85355 17.8536C8.94732 17.7598 9 17.6326 9 17.5V0.5C9 0.367392 8.94732 0.240215 8.85355 0.146447C8.75979 0.0526784 8.63261 0 8.5 0Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.e40d6ac5d086a6c4c978c4444c6e0ab0.svg";
export { ForwardRef as ReactComponent };